import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artuntergrp-list-view',
  imports: [],
  templateUrl: './artuntergrp.list-view.html',
  styleUrls: ['./artuntergrp.list-view.css'],
})
export class ArtuntergrpListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
